import * as React from 'react';

import type { ContentListViewScreenState } from 'modules/lists-content/types/ContentLists.type';

import ContentListLabeledSelect from '../labeled-select/ContentListLabeledSelect';

import { CONTENT_LIST_SORT_OPTIONS } from '../../utils/content';
import { __t, applyTranslations } from 'utils/language';

import type { ContentListStats, SelectOption } from 'types';

import './content-list-header.scss';

applyTranslations(require('./content-list-header.i18n.json'));

type Props = {
  stats: ContentListStats,
  screenState: ContentListViewScreenState,
  onScreenStateUpdate: (a: ContentListViewScreenState) => void
};

class ContentListHeader extends React.PureComponent<Props> {
  handleSortUpdate = (newSort: string): void => {
    const { screenState, onScreenStateUpdate } = this.props;
    onScreenStateUpdate({
      ...screenState,
      sortBy: newSort
    });
  };

  render(): React.ReactNode {
    const { screenState, stats } = this.props;
    const sortOptionsData: Array<SelectOption> = Object.keys(CONTENT_LIST_SORT_OPTIONS)
      .map((key) => ({
        label: CONTENT_LIST_SORT_OPTIONS[key],
        value: key
      }));

    return (
      <section className="content-list-header">
        <div className="content-list-header__metrics">
          <div>
            {__t('content_list_headers.amount_of_content_label')}
            <span className="content-list-header__metric-value">
              {stats.assetsCount}
            </span>
          </div>
          <div>
            {__t('content_list_headers.amount_of_creators_label')}
            <span className="content-list-header__metric-value">
              {stats.creatorsCount}
            </span>
          </div>
        </div>
        <ContentListLabeledSelect
          label={__t('content_list_headers.sort_by_label')}
          options={sortOptionsData}
          value={screenState.sortBy}
          onChange={this.handleSortUpdate}
        />
      </section>
    );
  }
}

export default ContentListHeader;
